import { modalModel } from 'entities/modal';
import { createAppAsyncThunk, getScannerTxLink, logger } from 'shared';
import { wagmiConfig } from 'shared/config/wagmi';
import { CIT_CROWDSALE_ABI } from 'shared/config/wallet-service/abi/citCrowdsaleAbi';
import { citCrowdsaleContract } from 'shared/config/wallet-service/contracts';
import { Address } from 'viem';
import { getChainId, writeContract } from 'wagmi/actions';

import { approve } from './approve';

type BuyArgs = {
  paymentAmount: bigint;
  referrer?: string;
};

export const buy = createAppAsyncThunk(
  'citCrowdsale/buy',
  async ({ paymentAmount, referrer }: BuyArgs, { rejectWithValue, dispatch }) => {
    try {
      try {
        await dispatch(approve({ amount: paymentAmount })).unwrap();
      } catch (err) {
        return rejectWithValue(err);
      }

      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.Send,
          transition: 'fade',
        }),
      );

      const txHash = await writeContract(wagmiConfig, {
        abi: CIT_CROWDSALE_ABI,
        address: citCrowdsaleContract.address,
        functionName: 'buy',
        args: [paymentAmount, referrer as Address],
      });

      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.SendSuccess,
          data: {
            transactionLink: getScannerTxLink(getChainId(wagmiConfig), txHash),
          },
          transition: 'fade',
        }),
      );

      return txHash;
    } catch (err) {
      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.SendReject,
          transition: 'fade',
        }),
      );

      logger('citCrowdsale/buy', err);
      return rejectWithValue(err);
    }
  },
);
